export default {
  inject: ['load'],
  data() {
    return {
      allPulseQualitiesForOther: [],
      pulseQuality: null,
    };
  },
  methods: {
    getListOfPulseQualitiesForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllPulseQualities').then(() => {
        if (this.$store.state.pulseQualityModule.successFlag) {
          this.allPulseQualitiesForOther = this.$store.state.pulseQualityModule.allPulseQualities;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.pulseQualityModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfPulseQualitiesForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getPulseQualityFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getPulseQuality', id).then(() => {
        if (this.$store.state.pulseQualityModule.successFlag) {
          this.pulseQuality = this.$store.state.pulseQualityModule.pulseQuality;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.pulseQualityModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getPulseQualityFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.pulseQualityModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
